import { Component, OnDestroy, OnInit } from '@angular/core';
import confetti from 'canvas-confetti';
@Component({
  selector: 'app-ganadores-tercer-sorteo-oportuno-2026',
  templateUrl: './ganadores-tercer-sorteo-oportuno-2026.component.html',
  styleUrls: ['./ganadores-tercer-sorteo-oportuno-2026.component.scss']
})
export class GanadoresTercerSorteoOportuno2026Component implements OnInit, OnDestroy {
 constructor() { }

  // La barra de "Mi Wallet" vive en el header compartido; esta clase en
  // el body deja subirla solo en esta pagina (ver _header.scss).
  ngOnInit(): void {
    document.body.classList.add('pagina-ganadores-tercer-oportuno');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('pagina-ganadores-tercer-oportuno');
  }

  ngAfterViewInit(): void {
    const duration = 2 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      // Desde la izquierda
      confetti({
        particleCount: 10,
        angle: 60,
        spread: 100,
        origin: { x: 0, y: 0.5 }
      });
      // Desde la derecha
      confetti({
        particleCount: 10,
        angle: 120,
        spread: 100,
        origin: { x: 1, y: 0.5 }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }
}
